declare global {
    interface Window {
        __ENV__?: Record<string, string>;
    }
}

export function getEnvVar(key: string): string | undefined {
    // Client-side runtime env
    if (typeof window !== "undefined" && window.__ENV__?.[key]) {
        return window.__ENV__[key];
    }

    // Fallback to build-time Next.js vars (works in local dev)
    const value = process.env[key];
    if (value) return value;

    console.warn(`⚠️ Env var ${key} not found in window.__ENV__ or process.env`);
    return undefined;
}
